import React, { useState, useEffect } from "react";
import TourInfo from "../components/tour-booking-confirmation/tour-info";

import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import BookingInfo from "../components/tour-booking-confirmation/booking-info";
import UserInfo from "../components/tour-booking-confirmation/user-info";
import PaymentInfo from "../components/tour-booking-confirmation/payment-info";
import BookingSuccessModal from "../components/tour-booking/booking-success-modal";
import { bookingService } from "../services/bookingService";
import { formatDate, formattedDateTime } from "../Helpers/BaseHelper";
const TourBookingConfirmationPage = () => {
  const { userInfo } = useSelector((state) => state.user);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const bookingId = queryParams.get("bookingId");

  const [booking, setBooking] = useState(null);
  const [showModal, setShowModal] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const handleClose = () => setShowModal(false);
  useEffect(() => {
    const fetchBooking = async () => {
      if (!bookingId) return;

      try {
        const data = await bookingService.getBookingById(bookingId);
        setBooking(data.data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchBooking();
  }, [bookingId]);

  if (loading) return <p>Đang tải...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div class="content">
      {userInfo && (
        <>
          <div class="container">
            <div className="row justify-content-center">
              <div className="col-lg-10">
                <div className="card booking-confirmation mb-0">
                  {" "}
                  <div className="card-body">
                    <TourInfo
                      bookingInfo={booking}
                      tourInfo={booking.tourResponse}
                    />
                    <BookingInfo
                      bookingInfo={booking}
                      formatDate={formatDate}
                      formattedDateTime={formattedDateTime}
                      tourInfo={booking.tourResponse}
                    />

                    {/* <div className="pb-4 border-bottom mb-4">
                      <h6 className="mb-2">Extra Service Info</h6>
                      <div className="d-flex flex-wrap align-items-center service-info gap-3">
                        <span className="badge badge-light rounded-pill">
                          Local Expert Guides
                        </span>
                        <span className="badge badge-light rounded-pill">
                          Photography Services
                        </span>
                      </div>
                    </div>

                    <div className="pb-4 border-bottom mb-4">
                      <h6 className="mb-2">Activities</h6>
                      <div className="d-flex flex-wrap align-items-center service-info gap-3">
                        <span className="badge badge-light rounded-pill">
                          Sightseeing
                        </span>
                        <span className="badge badge-light rounded-pill">
                          Boat Tours
                        </span>
                      </div>
                    </div> */}

                    <UserInfo userInfo={userInfo} />
                    <PaymentInfo
                      formatDate={formatDate}
                      discount={booking.discountDTO}
                      paymentInfo={booking.paymentResponse}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <BookingSuccessModal
            booking={booking}
            show={showModal}
            onHide={handleClose}
          />
        </>
      )}
    </div>
  );
};

export default TourBookingConfirmationPage;
